export default {"src":"/polygon/_next/static/media/aave.173b0876.svg","height":800,"width":800};